import { selectCurrentIDToken } from '../store/slices/auth/authSelectors';
import { selectPermitApplicationData } from '../store/slices/apply/applySelectors';
import { selectConfigExpressApplyRentalStructureRequired } from '../store/slices/config/configSelectors';
import { getAPIManagerInstance } from './apiManager';
import { DECKARD_API_URL, httpMethodFunctions } from './common';
import { RENTAL_STRUCTURE_STATUS_ENUM } from '../common/enums';

import { sanitizePeople } from './utils';

export const getStripePublicKey = async () => {
  const { data } = await httpMethodFunctions.get(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/stripe-public`
  );
  return data;
};

export const payGeneric = async (paymentId, signatory, email) => {
  const { data } = await httpMethodFunctions.post(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/payGeneric`,
    {
      paymentId,
      signatory,
      email,
    }
  );
  return data;
};

export const payByCreditCard = async (paymentID, signatoryName, email) => {
  const { data } = await httpMethodFunctions.post(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/payCC`,
    {
      paymentId: paymentID,
      signatory: signatoryName,
      email: email,
    }
  );
  return data;
};

export const payByACHDirectDebit = async (paymentID, signatoryName, email) => {
  const { data } = await httpMethodFunctions.post(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/payACHDirectDebit`,
    {
      paymentId: paymentID,
      signatory: signatoryName,
      email: email,
    }
  );
  return data;
};

export const payByCheck = async (paymentID, signatoryName, email) => {
  const { data } = await httpMethodFunctions.post(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/payCheck`,
    {
      paymentId: paymentID,
      signatory: signatoryName,
      email: email,
    }
  );
  return data;
};

export const calculateMultiPropertyTotAsync = async (state, body) => {
  const accessToken = selectCurrentIDToken(state);
  return await httpMethodFunctions.post(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/calculateMultiPropertyTot`,
    {
      ...body,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};

export const payNothingGeneric = async (
  state,
  paymentID,
  signatoryName,
  email
) => {
  const accessToken = selectCurrentIDToken(state);

  const payNothingConfig = {
    signatory: signatoryName,
    paymentId: paymentID,
    email: email,
  };

  const { data } = await httpMethodFunctions.post(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/payNothing`,
    {
      ...payNothingConfig,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return data;
};

export const checkTaxPayment = async (state, paymentID) => {
  const accessToken = selectCurrentIDToken(state);
  const { data } = await httpMethodFunctions.get(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/checkTotPayment/${paymentID}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return data;
};

export const checkLicensePayment = async (state, paymentID) => {
  const accessToken = selectCurrentIDToken(state);
  const { data } = await httpMethodFunctions.get(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/checkRenewalPayment/${paymentID}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return data;
};

export const payNothing = async (state, paymentID, signatoryName, email) => {
  const {
    registrant,
    property,
    contacts,
    propertyDetails,
    listings,
    certifications,
  } = selectPermitApplicationData(state);
  const apn = property.propertyid;
  const accessToken = selectCurrentIDToken(state);

  const rentalStructureRequiredStatus =
    selectConfigExpressApplyRentalStructureRequired(state);

  let people = {
    ...sanitizePeople(registrant),
    ...sanitizePeople(contacts),
  };
  delete people.registrantType;
  people.owner = [people.owner];

  const payNothingConfig = {
    registrantType: registrant.registrantType,
    unitNumber: property.unitnumber,
    // only add rentalStructure property if it is not set to hidden in the config
    ...(rentalStructureRequiredStatus !==
      RENTAL_STRUCTURE_STATUS_ENUM.HIDDEN && {
      rentalStructure: property?.rentalstructure ?? null,
    }),
    misc: {
      supplementalQuestions: { ...propertyDetails?.supplementalQuestions },
      mandatoryAcknowledgements: {
        ...certifications.mandatoryAcknowledgements,
      },
    },
    people: { ...people },
    signatory: certifications.signatory,
    paymentId: paymentID,
    email: email,
  };

  const { data } = await httpMethodFunctions.post(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/payNothing`,
    {
      ...payNothingConfig,
    }
  );
  return data;
};
